<template>
  <div class="addressBox">
    <div class="addAddressBox">
      <span class="addAddressBtn" @click="addAddressBtn">新增收货地址</span>
    </div>
    <div class="addressList clearfix sub-main">
      <div
        class="addressItem"
        :class="{ active: item.defult }"
        v-for="item of addressData"
        :key="item.receiveId"
      >
        <div class="listItemInfoBox">
          <div class="isDefault" v-if="item.isDefault === 1">
            <span style="color: red;">默认地址</span>
          </div>
          <div class="isDefault" v-else>
            <span>设为默认地址</span>
            <el-switch
              v-model="item.defult"
              @change="changeDefultAd(item)"
              active-color="#D22929"
              inactive-color="#c1c1c1"
            >
            </el-switch>
          </div>

          <div class="addressInfo">
            <div maxlength="50" class="infoItem">收货人：{{ item.realName }}</div>
            <div class="infoItem">
              所在地区：{{ item.province }}-{{ item.city }}-{{ item.district }}
            </div>
            <div maxlength="50" class="infoItem">详细地址：{{ item.detail }}</div>
            <div maxlength="11" class="infoItem">手机号：{{ item.phone }}</div>
          </div>
        </div>

        <div class="addressChange">
          <span @click="showDelete(item)"
          ><i class="iconfont">&#xe62c;</i>删除</span
          >
          <span @click="changeAddress(item)"
          ><i class="iconfont">&#xe605;</i>修改</span
          >
          <div v-show="item.isDefault" class="iconfont defaultActive">
            &#xe612;
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <el-pagination
        class=""
        background
        layout="prev, pager, next, jumper"
        :page-size="4"
        :current-page="page"
        @current-change="handleCurrentChange"
        :total="addressData.total"
      >
      </el-pagination>
    </div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addAddressShow" width="30%">
      <add-address @hideAddDialog="hideAddDialog" @cancelAdd="closeAdd" ref="addAddr"></add-address>
    </el-dialog>
    <el-dialog title="是否删除此项" :visible.sync="showDeleteAdd" width="30%">
      <div class="deleteAddInfo">
        <p>收货人： {{ delCurrentAdd.realName }}</p>
        <p>手机号码： {{ delCurrentAdd.phone }}</p>
        <p>
          收货地址： {{ delCurrentAdd.province }}-{{ delCurrentAdd.city }}-{{
            delCurrentAdd.district
          }}
          {{ delCurrentAdd.detail }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteAdd" v-throttle
        >确 定</el-button
        >
        <el-button @click="showDeleteAdd = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import addAddress from "../../../components/orderInfo/addAddress";
import {TextToCode} from "element-china-area-data";
import api from "@/api";
import {listSearchMixin} from "@/config/mixin";
import {mapGetters, mapMutations} from "vuex";
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  name: "signingAddress",
  mixins: [listSearchMixin],
  components: {
    addAddress,
  },
  data() {
    return {
      isDefault: false,
      showDeleteAdd: false,
      addAddressShow: false,
      title: "",
      page: 1,
      pageSize: 4,
      addressData: [],
      delCurrentAdd: {},
      updateAddressDate: {},
      regionData: regionData
    };
  },
  mounted() {
    this.getAddressList();
  },
  computed: {
    ...mapGetters([
      "newAddress", // 新增修改收货地址
    ]),
  },
  methods: {
    ...mapMutations({
      seNewAddress: "SET_NEWADDRESS", // 新增修改收货地址
      setAreacode: "SET_AREACODE", // 新增修改收货地址
    }),
    getAddressList() {
      const rLoading = this.openLoading();
      let self = this;
      let params = {
        url: api.addressList + `?page=${self.page}&pageSize=${self.pageSize}`,
        method: "GET",
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.addressData = res.data;
          rLoading.close();
        }
      });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getAddressList();
    },
    showDelete(item) {
      this.showDeleteAdd = true;
      this.delCurrentAdd = item;
    },
    // 删除地址
    deleteAdd(item) {
      let self = this;
      let params = {
        url: api.delAddress,
        method: "post",
        data: {
          id: this.delCurrentAdd.id,
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.showDeleteAdd = false;
          self.$message({
            message: "删除成功",
            type: "success",
          });
          self.page = 0;
          self.addressData = [];
          self.getAddressList();
        } else {
          self.$message.error(res.message);
        }
      });
      self.showDeleteAdd = false;
    },
    // 修改默认地址
    changeDefultAd(item) {
      this.seNewAddress(item);
      let params = {
        url: api.setDefault,
        method: "POST",
        data: {
          id: item.id,
        },
      };
      var self = this;
      this.sendReq(params, (res) => {
        self.getAddressList();
      });
    },
    // 修改地址信息
    changeAddress (item) {
      this.title = '修改收货地址'
      this.updateAddressDate = item
      if (item.isDefault == 1) {
        item.isDefault = true
      } else {
        item.isDefault = false
      }
      this.seNewAddress(item);
      let areaData = [];
      // areaData.push(item.district);
      let provIndex = this.regionData.findIndex(i => i.label == item.province)
      let cityIndex = this.regionData[provIndex].children.findIndex(i => i.label == item.city)
      if(this.regionData[provIndex].children.length == 1) cityIndex = 0
      let distIndex = this.regionData[provIndex].children[cityIndex].children.findIndex(i => i.label == item.district)
      areaData.push(this.regionData[provIndex].value)
      areaData.push(this.regionData[provIndex].children[cityIndex].value)
      areaData.push(this.regionData[provIndex].children[cityIndex].children[distIndex].value)
	  if(this.$refs.addAddr) this.$refs.addAddr.addressChange(areaData)
      this.setAreacode(areaData);
      let currentItem = JSON.parse(JSON.stringify(item))
      this.seNewAddress(currentItem)
      this.addAddressShow = true;
    },
    addAddressBtn() {
      this.updateAddressDate = {}
      let obj = {
        receiveName: "",
        phone: "",
        detail: "",
        isDefault: false,
      };
      this.setAreacode([]);
      this.title = "新增收货地址";
      this.seNewAddress(obj);
      this.addAddressShow = true;
    },
    // 新增地址
    hideAddDialog(isDefault) {
      this.addAddressShow = false;
	  isDefault = isDefault || 0
      let self = this;
      let params = {
        url: api.newAddress,
        method: "POST",
        data: {
          id: this.updateAddressDate.id ? this.updateAddressDate.id : '',
          real_name: this.newAddress.realName,
          phone: this.newAddress.phone,
          addressInfo: this.newAddress.receiveAdress,
          detail: this.newAddress.detail,
          label: "",
          is_default: isDefault==1 ? true : false,
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: this.updateAddressDate.id ? '地址修改成功' : '地址添加成功',
            type: "success",
          });
          self.page = 1;
          self.addressData = [];
          self.setAreacode([]);
          self.getAddressList();
        } else {
          self.$message.error(res.message);
        }
      });
      this.newAddress.isDefault=1;
    },
    // 修改地址
    updateAddressFun() {
      let self = this;
      self.addAddressShow = false;
      let params = {
        url: api.updateAddress,
        method: "post",
        data: {
          receiveId: self.newAddress.receiveId,
          real_name: self.newAddress.receiveName,
          phone: self.newAddress.receivePhone,
          receiveAdress: self.newAddress.receiveAdress,
          addressInfo: self.newAddress.address,
          label: "",
          is_default: self.newAddress.defult.toString(),
        },
      };
      self.sendReq(params, (res) => {
      })
    },
    closeAdd() {
      this.addAddressShow = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.addressBox {
  padding: 30px;
  border: 1px solid #e5e5e5;
  min-height: 500px;

  .addAddressBtn {
    font-size: 14px;
    color: $mainColor;
    height: 40px;
    line-height: 32px;
    background: #ffffff;
    border: 1px solid $mainColor;
    border-radius: 4px;
    padding: 4px 20px;
    cursor: pointer;
  }

  .addressList {
    margin-top: 20px;

    .addressItem {
      &:nth-child(2n) {
        margin-right: 20px;
      }

      width: 310px;
      border: 2px solid #dddddd;
      border-radius: 8px;
      box-sizing: border-box;
      margin-right: 20px;
      margin-bottom: 20px;
      box-shadow: 5px 5px 0 #F7F7F7;
      float: left;

      .listItemInfoBox {
        padding: 20px;

        .isDefault {
          display: flex;
          align-items: center;
          height: 35px;
          justify-content: flex-end;

          span {
            color: #333333;
            font-size: 12px;
            margin-right: 5px;
          }
        }

        .addressInfo {
          .infoItem {
            color: #333333;
            font-size: 12px;
            margin-bottom: 10px;
          }

          .infoItem:last-child {
            margin-bottom: 0;
          }
        }
      }

      .addressChange {
        border-top: #cccccc solid 1px;
        height: 35px;
        line-height: 35px;
        position: relative;
        font-size: 14px;

        i {
          margin-right: 5px;
        }

        .defaultActive {
          position: absolute;
          right: -1px;
          bottom: -3px;
          width: 36px;
          height: 37px;
          color: $mainColor;
          font-size: 34px;
        }

        span {
          display: block;
          float: left;
          width: 50%;
          color: #666666;
          text-align: center;
          cursor: pointer;
        }

        span:nth-child(2) {
          border-left: 1px solid #cccccc;
          color: $mainColor;
          box-sizing: border-box;
        }
      }
    }

    .active {
      border: 2px solid $mainColor;
    }
  }

  > > > .el-dialog {
    width: 33% !important;

    .el-dialog__body {
      background: #f8f8f8;
    }

    .el-dialog__header {
      text-align: center;
    }

    .dialog-footer {
      display: flex;
      justify-content: center;
      width: 100%;

      button {
        height: 45px;
        width: 120px;
      }
    }
  }

  .deleteAddInfo {
    width: 70%;
    margin: 0 auto;

    p {
      line-height: 30px;
    }
  }

  > > > .el-pagination {
    text-align: right;
  }
}

.sub-main {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/signingAddress/signingAddress.vue